
import { Vue, Component, Prop } from 'vue-property-decorator';

interface AddingRules {
  regexp: RegExp,
  message: string,
}

@Component
export default class MultipleInput extends Vue {
  @Prop({ required: true }) items!: Array<string>;

  @Prop({ default: '' }) label!: string;

  @Prop({ default: 40 }) height!: number;

  @Prop({ required: true }) rules!: [];

  @Prop({ default: () => ({}) }) addingRules!: AddingRules;

  @Prop({ default: '' }) value!: '';

  @Prop({ default: '' }) ariaLabel!: '';

  @Prop({ default: 5 }) max!: number;

  private messages: Array<string> = [];

  get currentValue(): string {
    return this.value;
  }

  set currentValue(val: string) {
    this.$emit('input', val);
  }

  private addItem(): void {
    if (this.currentValue) {
      if (!this.items.includes(this.currentValue)) {
        if (this.items.length < this.max) {
          const valid = this.addingRules.regexp
            ? (this.addingRules.regexp as RegExp).test(this.currentValue)
            : true;

          if (valid) {
            this.$emit('added');
          } else {
            this.addMessage(this.addingRules.message as string);
          }
        } else {
          this.addMessage(`Max ${this.max} items`);
        }
      } else {
        this.addMessage('Duplicate value');
      }
    } else {
      this.addMessage('Can not be empty');
    }
  }

  private deleteItem(idx: number): void {
    this.$emit('deleted', idx);
  }

  private addMessage(str: string): void {
    if (!this.messages.includes(str)) {
      this.messages.push(str);

      setTimeout(() => {
        this.messages = [];
      }, 2000);
    }
  }
}
